import { render, staticRenderFns } from "./_ContentTemplates.vue?vue&type=template&id=216b24bc&scoped=true&"
import script from "./_ContentTemplates.vue?vue&type=script&lang=ts&"
export * from "./_ContentTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./_ContentTemplates.vue?vue&type=style&index=0&id=216b24bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b24bc",
  null
  
)

export default component.exports